// extracted by mini-css-extract-plugin
export default {"item":"drawer_item_MbG2q","current":"drawer_current_quRzn","draggable":"drawer_draggable_XpFMK"};